import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

type CatalogToolbarProps = {
  language: 'mn' | 'en';
  title: string;
  count: number;
  isLoading: boolean;
  loadError: string | null;
  sortBy: 'newest' | 'price-low' | 'price-high';
  onSortChange: (value: 'newest' | 'price-low' | 'price-high') => void;
};

export function CatalogToolbar({
  language,
  title,
  count,
  isLoading,
  loadError,
  sortBy,
  onSortChange,
}: CatalogToolbarProps) {
  return (
    <div className="mb-5 rounded-[15px] border border-[var(--ubuy-border-soft)] bg-white px-4 py-4 shadow-sm sm:px-5">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <p className="mb-2 text-[11px] font-bold uppercase tracking-[0.24em] text-[var(--ubuy-muted)]">
            {language === 'mn' ? 'Catalog focus' : 'Catalog focus'}
          </p>
          <div className="flex flex-wrap items-end gap-x-3 gap-y-1">
            <h1 className="text-[26px] font-bold leading-tight text-[var(--ubuy-title)] sm:text-[30px]">{title}</h1>
            {!isLoading && !loadError ? (
              <p className="pb-1 text-sm text-[var(--ubuy-muted)]">
                {count} {language === 'mn' ? 'бараа' : 'items'}
              </p>
            ) : null}
          </div>
        </div>

        <div className="flex items-center gap-3 self-start sm:self-auto">
          <span className="hidden rounded-full bg-[var(--ubuy-subtle-surface)] px-3 py-1.5 text-xs font-bold text-[var(--ubuy-title)] md:inline-flex">
            {language === 'mn' ? 'Эрэмбэлэлт' : 'Sort'}
          </span>
          <Select value={sortBy} onValueChange={(value) => onSortChange(value as typeof sortBy)}>
            <SelectTrigger className="h-11 w-full rounded-[12px] border border-[var(--ubuy-border-soft)] bg-white text-sm font-medium text-[var(--ubuy-title)] shadow-none sm:w-[230px]">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="newest">{language === 'mn' ? 'Шинэ' : 'Newest'}</SelectItem>
              <SelectItem value="price-low">
                {language === 'mn' ? 'Үнэ: бага -> их' : 'Price: Low to High'}
              </SelectItem>
              <SelectItem value="price-high">
                {language === 'mn' ? 'Үнэ: их -> бага' : 'Price: High to Low'}
              </SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
}
